import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import es from '../../assets/i18n/es.json';
import en from '../../assets/i18n/en.json';

const translations: Record<string, TranslationObject> = {
  es: es as TranslationObject,
  en: en as TranslationObject,
};

@Injectable()
export class AppTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<TranslationObject> {
    return of(translations[lang] ?? {});
  }
}
